import { useState } from "react";
import { components } from '../components';
import Enums from "../helpers/enums";
import utils from "../helpers/utils";
import { hooks } from "../hooks";
import ApiService from "../service/ApiService";
import { setPaymentMethod } from "../store/slices/appSlice";
import TyroPayment from "./TyroComponent";
import { isEmpty } from "lodash";
import { Routes } from "../routes";
import { showErrorToast } from "../components/Toast";
import constants from "../helpers/constants";

interface AddPaymentMethodProps {
    paymentRequest: {
        id: string | number;
        payType: string;
        paySecret?: string;
    };
    onClose: () => any;
    isDefaultSave?: boolean;
    onAddPayment: () => any;
}

export const AddPaymentMethod: React.FC<AddPaymentMethodProps> = ({
    paymentRequest,
    onClose,
    isDefaultSave = false,
    onAddPayment
}) => {
    const dispatch = hooks.useDispatch();
    const navigate = hooks.useNavigate();
    const applePayEnabled = paymentRequest.payType === Enums.payType.Wallet;
    const [isLoading, setLoading] = useState<boolean>(false);

    const savePaymentMethod = async (saveforFuture: boolean) => {
        setLoading(true);
        const { data, error } = await ApiService.savePaymentMethodAsync(
            String(paymentRequest.id),
            saveforFuture
        );
        if (data) {
            dispatch(setPaymentMethod(data));
            onAddPayment();
            onClose();
            if (!saveforFuture) {
                navigate(Routes.Checkout);
            }
        } else if (error) {
            showErrorToast(error || constants.defaultErrorMessage);
            onClose();
        }
        setLoading(false);
    };

    const onMessage = (data: any) => {
        const message = JSON.parse(data);
        if (message.success === true) {
            if (paymentRequest.payType === Enums.payType.Wallet) {
                dispatch(
                    setPaymentMethod({
                        brand: Enums.payType.Wallet,
                        paymentMethodId: paymentRequest.id,
                        payType: Enums.payType.Wallet
                    })
                );
                onClose();
            } else {
                savePaymentMethod(message.saveForFuture);
            }
        }
    };

    const renderLoader = (): JSX.Element | null => {
        if (isLoading) {
            return <components.Loader />;
        }
        return null;
    };

    return (
        <div
            style={{
                flex: 1,
                padding: 8,
                backgroundColor: "var(--main-background)",
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20
            }}
        >
            {isLoading ? (
                renderLoader()
            ) : (
                <div style={{ flex: 1 }}>
                    {!isEmpty(paymentRequest) && !isEmpty(paymentRequest.paySecret) && (
                        <TyroPayment
                            paySecret={String(paymentRequest.paySecret)}
                            isDefaultSave={isDefaultSave}
                            applePay={applePayEnabled}
                            onMessage={onMessage}
                        />
                    )}

                    {!applePayEnabled && (
                        <div style={{ marginBottom: 0 }}>
                            <p
                                className="t12"
                                style={{ backgroundColor: "var(--main-background)", textAlign: "center" }}
                            >
                                We accept all major debit and credit cards, including Visa,
                            </p>
                            <p
                                className="t12"
                                style={{ backgroundColor: "var(--main-background)", textAlign: "center" }}
                            >
                                Mastercard®, American Express, Diners Club, JCB, and UnionPay.
                            </p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
